/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsTriangleInfoEmpty: {
  name: 'triangle-info-empty';
  data: string;
} = {
  name: 'triangle-info-empty',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.447.776a.5.5 0 0 0-.894 0l-7 14A.5.5 0 0 0 1 15.5h14a.5.5 0 0 0 .447-.724l-7-14ZM8 2.118 14.191 14.5H1.809L8 2.118ZM8.5 6a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0ZM8 13.5a.5.5 0 0 0 .5-.5V8a.5.5 0 0 0-1 0v5a.5.5 0 0 0 .5.5Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
